exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-category .loading[data-v-c0e373d4] {\n  display: flex;\n  flex: 1;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  min-height: 468px;\n}\n.product-category .component-fade-enter-active[data-v-c0e373d4],\n.product-category .component-fade-leave-active[data-v-c0e373d4] {\n  transition: opacity 0.3s ease;\n}\n.product-category .component-fade-enter[data-v-c0e373d4], .product-category .component-fade-leave-to[data-v-c0e373d4] {\n  opacity: 0;\n}", ""]);

// exports
